import React, { Component, Fragment } from 'react';
import CloseActionButton from '../common/CloseActionButton';
import NotificationDetailsForm from './NotificationDetailsForm';

class NotificationEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        content: this.props.notification.content,
        name: this.props.notification.name,
        subject: this.props.notification.subject,
        description: this.props.notification.description,
      },
    };
  }

  render() {
    return (
      <Fragment>
        <div>
          <NotificationDetailsForm
            isLoading={this.props.isLoading}
            initialValues={this.state.initialValues}
            onSave={formData => this.props.onSave(formData)}
          />
        </div>
      </Fragment>
    );
  }
}

export default NotificationEdit;
